import { action, makeObservable, observable } from 'mobx';
import { ICompositeProductApi } from '@canvas-logic/clp-sdk';

import { ICompositeProductData } from '@canvas-logic/clp-domain';

import React from 'react';
import { IUICfgUICompositeProductInfoElementUI } from '@canvas-logic/clp-api-types';
import { CfgUIElementState } from '@/stores/CfgUIElementState';
import { CompositeProductInfoUIElement } from '@/UiBuilder/elements/CompositeProductInfoUIElement/CompositeProductInfoUIElement';

let id = 0;

export interface Color {
  ral: string;
  hex: string;
}

export class CompositeProductInfoCfgUIElementState extends CfgUIElementState {
  public id = 'ral-view-state-' + ++id;

  loading = false;
  productData: ICompositeProductData;

  constructor(public readonly api: ICompositeProductApi, public viewElement: IUICfgUICompositeProductInfoElementUI) {
    super();

    makeObservable(this, {
      loading: observable,
      update: action.bound,
    });

    this.productData = this.api.getProductData();
  }

  get title(): string {
    return this.productData.texts.name;
  }

  get description(): string {
    return this.productData.texts.description;
  }

  get shortDescription() {
    return this.productData.texts.shortDescription;
  }

  render(): React.ReactElement {
    return <CompositeProductInfoUIElement key={this.id} state={this} />;
  }
}
